var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-modal",on:{"click":function($event){$event.stopPropagation();return _vm.close.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/images/common/intro.png"),"alt":"intro"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }